import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { DatatableColumn } from 'projects/bis-shared/src/lib/datatable/datatable-column';
import { DatatableSort } from 'projects/bis-shared/src/lib/datatable/datatable-sort';
import { Router } from '@angular/router';
import { DatatableComponent } from 'projects/bis-shared/src/lib/datatable/datatable/datatable.component';
import { ObjectTypeCode } from 'projects/bis-shared/src/lib/utility/system-type-constants';
import { SnackbarService } from 'projects/bis-shared/src/lib/snackbar/snackbar.service';
import { RecentDownload } from '../recent-download';
import { DatatableStaticTemplateType } from 'projects/bis-shared/src/lib/datatable/datatable-static-template';
import { ExternalApiUrls } from 'projects/bis-shared/src/lib/utility/apiurls-external';
import { AppUrls } from 'projects/bis-shared/src/lib/utility/appurls';
import { DocumentService } from '../../document/document.service';

@Component({
  selector: 'app-recent-downloads',
  templateUrl: './recent-downloads.component.html',
  styleUrls: ['./recent-downloads.component.scss'],
})
export class RecentDownloadsComponent implements OnInit {
  @ViewChild('relatedIdTemplate', { static: true }) relatedIdTemplate: TemplateRef<any>;
  @ViewChild('fileNameTemplate', { static: true }) fileNameTemplate: TemplateRef<any>;
  @ViewChild('dateTemplate', { static: true }) dateTemplate: TemplateRef<any>;
  @ViewChild('relatedObjectTypeTemplate', { static: true })
  relatedObjectTypeTemplate: TemplateRef<any>;
  @ViewChild(DatatableComponent, { static: true }) datatableComponent: DatatableComponent;

  columns: DatatableColumn[];
  dataUrl: string;
  defaultSort: DatatableSort[];
  documentTypeCode = ObjectTypeCode;

  constructor(
    private externalApiUrls: ExternalApiUrls,
    private router: Router,
    private snackbarService: SnackbarService,
    private docService: DocumentService,
  ) {
    this.defaultSort = [
      {
        property: 'downloadDate',
        sortAscending: false,
      },
      {
        property: 'fileName',
        sortAscending: true,
      },
    ];

    this.dataUrl = this.externalApiUrls.document.recentDownloads();
  }

  ngOnInit(): void {
    this.columns = [
      {
        title: 'File Name',
        property: 'fileName',
        template: this.fileNameTemplate,
        width: 350,
      },
      {
        title: 'Related ID',
        property: 'relatedSystemIdFormatted',
        template: this.relatedIdTemplate,
        width: 200,
      },
      {
        title: 'Related Object Type',
        property: 'relatedSystemTypeName',
        template: this.relatedObjectTypeTemplate,
        width: 200,
      },
      {
        title: 'Date Downloaded',
        property: 'downloadDate',
        width: 200,
        template: DatatableStaticTemplateType.EasternDateTimeTemplate,
      },
    ];

    this.datatableComponent.emptyMessage = 'No files downloaded in the last 24 hours.';
  }

  download(document: RecentDownload) {
    if (document.includeChildren) {
      this.docService.downloadRelated(document.documentId, document.receivedDate);
    } else {
      this.docService.download(document.documentId, document.receivedDate);
    }
  }

  goToDetails(id: number, typeCode: ObjectTypeCode) {
    const link = AppUrls.detailsForSystemType(id, typeCode);
    if (link) {
      this.router.navigate([link]);
    } else {
      this.snackbarService.openSnackBarFailure('Could not route to reqested page.');
    }
  }
}
